// removed by extract-text-webpack-plugin
module.exports = {"container":"LanguagePicker__container__11OjB","activeDiv":"LanguagePicker__activeDiv__26o-W","lightTheme":"LanguagePicker__lightTheme__3Bts-","buttonBox":"LanguagePicker__buttonBox__3ouuG","active":"LanguagePicker__active__1Fno8","activeLight":"LanguagePicker__activeLight__zaFUM","imgFlag":"LanguagePicker__imgFlag__2ed-4","lblName":"LanguagePicker__lblName__1zU6A","lightThemeLabel":"LanguagePicker__lightThemeLabel__13imi","indicator":"LanguagePicker__indicator__5i7kA"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Navigation/LanguagePicker/LanguagePicker.css
// module id = 446
// module chunks = 0